import { Api } from '@/constants';

export const getAsset = (asset: string) => {
  return `${Api.EdupassApi}/contents/assets/${asset}`;
};
